import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { login } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import SEO from '../../Components/shared/SEO';

const ROLE_DASHBOARD = {
  client: '/dashboard',
  therapist: '/therapist',
  venue: '/venue',
  admin: '/admin'
};

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const { user } = await login(form);
      await refresh();
      // If we were redirected here from a page like /book-massage, go back there.
      navigate(location.state?.from || ROLE_DASHBOARD[user.role] || '/');
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <SEO title="Log In" path="/login" noIndex />
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Log in</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            value={form.email}
            onChange={(e) => setForm(prev => ({ ...prev, email: e.target.value }))}
            placeholder="Email"
            className="w-full p-3 border rounded-lg"
            required
          />
          <input
            type="password"
            value={form.password}
            onChange={(e) => setForm(prev => ({ ...prev, password: e.target.value }))}
            placeholder="Password"
            className="w-full p-3 border rounded-lg"
            required
          />
          {error && <p className="text-red-500 text-sm text-center">{error}</p>}
          <button type="submit" disabled={isLoading}
            className={`w-full bg-black text-white p-3 rounded-lg font-medium hover:bg-gray-800 transition-colors ${isLoading ? 'opacity-50' : ''}`}>
            {isLoading ? 'Logging in...' : 'Log in'}
          </button>
        </form>
        <p className="text-sm text-center text-gray-600 mt-4">
          No account? <a href="/signup" className="text-blue-600">Sign up</a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
